import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MixpanelServiceService } from '../../services/mixpanel/mixpanel-service.service';
import { DashboardProfileService } from '../../services/dashboardProfile/dashboard-profile.service';
import { Config } from '../../containers/glimpse-layout/components/nav-list/nav.config';
import { setUserData } from '../../util/manageUserData';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.css'],
})
export class LogInComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private serviceAuth: AuthService,
    private router: Router,
    private mixpanelService: MixpanelServiceService,
    private dbProfileService: DashboardProfileService,
  ) {
    this.loginForm = this.fb.group({
      userName: ['', [Validators.required, Validators.pattern(/\S+@\S+\.\S+/)]],
      password: ['', [Validators.required]],
    });
  }
  config: Config = new Config();
  readonly isOAuth = environment.client_env === 'pandg' ? true : false;

  image_key = environment.client_env;
  //@ts-ignore
  imageUrl = environment[this.image_key]['sidebar_image'];
  loginForm: FormGroup;
  userName: String = '';
  password: String = '';
  errorMessageUserName = '';
  errorMessagePassword = '';
  errorMsg = 'Error';
  submited = false;
  failedAuth = false;
  bottonLabel = environment.client_env == 'pandg' ? 'Next' : 'Login';
  ngOnInit() {}

  get f() {
    return this.loginForm.controls;
  }
  onSubmit(form: FormGroup) {
    this.submited = true;

    if (form.valid) {
      this.serviceAuth
        .loginUser(form.value['userName'], form.value['password'])
        .then((result) => {
          if (result['success'] === '1') {
            setUserData(result['data']);
            var token = result['data']['token'];
            this.dbProfileService.getOwnerProfileDataService(
              token,
              form.value.userName,
            );
            // this.router.navigateByUrl('');
            let project_key = environment.client_env;
            let firstItem = this.config.getFirstNavItem();
            if (firstItem) {
              environment[project_key]['home_route'] = firstItem.path;
            }
            let homeRoute = environment[project_key]['home_route'];

            if (homeRoute) {
              this.router.navigateByUrl(homeRoute);
            } else {
              this.router.navigateByUrl('/footfall');
            }
            this.mixpanelFunction();
          } else {
            this.errorMsg = result['message'];
            this.failedAuth = true;
          }
        })
        .catch((error) => {});
    }
  }
  resetForm() {
    this.submited = false;
    this.failedAuth = false;
  }

  mixpanelFunction() {
    this.mixpanelService.track('Log in', {});
  }
  loginRedirect() {
    window.location.href =
      'https://fedauth.pg.com/as/authorization.oauth2?client_id=GlimpseSurakshaClientID&response_type=code&scope=edit+pingid&pfidpadapterid=Oauth';
  }
}
